import React, { useEffect, useState } from "react";
import { renderError } from "../../../helpers/errors";
import { createOptions } from "../../../helpers/selects";
import api from "../../../services/api";
import InputSelect from "../../InputSelect";

export const SelectCustomization = ({selectedCustomization, setSelectedCustomization, className, updating, label}) => {
    const [loading, setLoading] = useState(true);

    const [customizations, setCustomizations] = useState([]);

    useEffect(() => {
        getCustomizations();
    }, []);

    const getCustomizations = () => {
        setLoading(true);

        api.get(`/customization`).then(res => {
            setCustomizations(res.data.resources);
        }).catch(error => {
            renderError(error);
        }).then(() => {
            setLoading(false);
        });
    }

    return (
        <div className={className ?? ''}>
            <InputSelect
                loading={loading || updating === true}
                label={label ?? `Gravação`}
                options={createOptions(customizations, 'name', 'id')} 
                value={selectedCustomization} 
                change={setSelectedCustomization}
            />
        </div>
    );
}

export default SelectCustomization;